export const Badge = {
  sizes: {
    sm: {
      h: 5,
      minW: 5,
      px: 1,
      py: 1,
      fontSize: 'xs'
    },
    md: {
      h: 6,
      minW: 6,
      px: 2,
      py: 1,
      fontSize: 'sm'
    },
    lg: {
      h: 7,
      px: 2,
      py: 1,
      fontSize: 'md'
    },
    xl: {
      h: 8,
      px: 3,
      py: 1,
      fontSize: 'lg'
    }
  },

  variants: {
    error: {
      bg: 'brand.error',
      color: 'brand.error-alt'
    },
    warning: {
      bg: 'brand.warning',
      color: 'brand.warning-alt'
    },
    success: {
      bg: 'brand.success',
      color: 'brand.success-alt'
    },
    default: {
      bg: 'brand.hover',
      color: 'brand.muted'
    },
    outline: {
      borderWidth: '1px',
      borderColor: 'brand.border',
      boxShadow: 'none',
      bg: 'transparent',
      color: 'brand.muted'
    }
  },
  baseStyle: {
    textTransform: 'capitalize',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '3px',
    fontWeight: 'bold'
  },
  defaultProps: {
    size: 'md',
    variant: 'default'
  }
}
